import { useTranslation } from 'react-i18next';
import CatalogListHeader from '../../../components/CatalogListHeader/CatalogListHeader';
import { Grid } from '@mantine/core';
import CatalogContainer from '../../../components/CatalogContainer/CatalogContainer';
import moment from 'moment';
import { DateValue, MonthPickerInput } from '@mantine/dates';
import { useState } from 'react';
import FullYearSalesGraph from './FullYearSalesGraph';
import PaymentMethodsChart from './PaymentMethodsChart';
import TopTenProductsChart from './TopTenProductsChart';
import PopularDaysChart from './PopularDaysChart';
import MonthSalesChart from './MonthSalesChart';

export interface CommonReportChartProps {
  dateRange: [DateValue, DateValue];
  chartHeight: number;
}
export const graphColors = [
  { name: 'Main Blue', hex: '#003684' },
  { name: 'Dark Blue', hex: '#001f4d' },
  { name: 'Light Blue', hex: '#4a90e2' },
  { name: 'Teal', hex: '#00a6a6' },
  { name: 'Green', hex: '#28a745' },
  { name: 'Yellow', hex: '#ffc107' },
  { name: 'Orange', hex: '#ff7f0e' },
  { name: 'Red', hex: '#dc3545' },
  { name: 'Purple', hex: '#6f42c1' },
  { name: 'Pink', hex: '#d63384' }
];

const GeneralViewReport = () => {
  const chartHeight = 300;
  const { t } = useTranslation(['ReportsPage', 'FieldName', 'CommonButtons', 'Notifications']);
  const [dateRangePicker, setDateRange] = useState<[DateValue, DateValue]>([
    moment().startOf('month').toDate(),
    moment().endOf('month').toDate()
  ]);

  return (
    <CatalogContainer>
      <CatalogListHeader
        title={t('ReportsPage:generalViewReport.title')}
        showCreateButton={false}
      />
      <Grid>
        <Grid.Col span={12}>
          <FullYearSalesGraph />
        </Grid.Col>
        <Grid.Col span={{ xs: 12, md: 12 }}>
          <MonthPickerInput
            clearable={false}
            type="default"
            label={t('FieldName:date')}
            placeholder={t('FieldName:date')}
            value={dateRangePicker[0]}
            onChange={(value) => {
              setDateRange([
                moment(value).startOf('month').toDate(),
                moment(value).endOf('month').toDate()
              ]);
            }}
          />
        </Grid.Col>
        <Grid.Col span={{ xs: 12, md: 6 }}>
          <PaymentMethodsChart chartHeight={chartHeight} dateRange={dateRangePicker} />
        </Grid.Col>
        <Grid.Col span={{ xs: 12, md: 6 }}>
          <TopTenProductsChart chartHeight={chartHeight} dateRange={dateRangePicker} />
        </Grid.Col>
        <Grid.Col span={{ xs: 12, md: 6 }}>
          <MonthSalesChart chartHeight={chartHeight} dateRange={dateRangePicker} />
        </Grid.Col>
        <Grid.Col span={{ xs: 12, md: 6 }}>
          <PopularDaysChart chartHeight={chartHeight} dateRange={dateRangePicker} />
        </Grid.Col>
      </Grid>
    </CatalogContainer>
  );
};

export default GeneralViewReport;
